<template>
  <!--
    A bespoke, demo-only switcher row. It deliberately does NOT reuse
    Menu.CheckboxItem (which is a single-line, icon + label control) — the demo
    switcher wants a multi-line row (name / description / username) with no
    icon, so we compose the Reka primitive directly here rather than adding
    one-off props to the shared design-system component. The parent forces the
    menu to float in demo mode, so DropdownMenuItem always has its context.
  -->
  <DropdownMenuItem as-child @select="emit('select')">
    <button
      type="button"
      :class="[
        'group/item relative flex w-full shrink-0 cursor-pointer select-none items-start gap-2 rounded-md border-none px-3 py-1.5 text-left text-sm text-current outline-none',
        'active:bg-menu-muted data-[highlighted]:bg-menu-muted',
        newsletter.status === 'dormant' && 'opacity-50',
      ]"
    >
      <span class="flex min-w-0 grow flex-col gap-0.5">
        <span class="font-medium">
          {{ newsletter.name || newsletter.username }}
        </span>
        <span
          v-if="newsletter.description"
          class="text-xs text-menu-muted-foreground"
        >
          {{ newsletter.description }}
        </span>
      </span>

      <CheckIcon v-if="current" class="mt-0.5 size-4 shrink-0 text-blue-400" />
    </button>
  </DropdownMenuItem>
</template>

<script setup lang="ts">
import { DropdownMenuItem } from "reka-ui";

import CheckIcon from "@/icons/heroicons/check-micro.svg";
import type { Newsletter } from "@/types/newsletter";

defineProps<{
  newsletter: Newsletter;
  current: boolean;
}>();

const emit = defineEmits<{ select: [] }>();
</script>
